import { createQuery } from '../api/query'
import { InviteResponse, LoginResponse } from './types'

export const keyUser = [`/me`]
export const useQueryMe = createQuery<LoginResponse>({
    key: keyUser,
    url: '/me',
    options: {
        staleTime: 2 * 60 * 1000, // 2 min — avoid refetching /me on every nav; logout clears cache
    },
})

const useQueryInvite = createQuery<InviteResponse>({
    key: [`/invite`],
    url: '/invite',
})
void useQueryInvite
